/** Compact counts as in the report designs: 1200000 → "1.2M", 184000 → "184K", 950 → "950". */
export const compactNumber = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return '';
  const abs = Math.abs(number);
  if (abs >= 1e6) return `${(number / 1e6).toFixed(1).replace(/\.0$/, '')}M`;
  if (abs >= 1e3) return `${Math.round(number / 1e3)}K`;
  return String(Math.round(number));
};

/** Engagement rate as a percent string: 0.031 or 3.1 → "3.1%". */
export const formatRate = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return null;
  const pct = number <= 1 ? number * 100 : number;
  return `${pct.toFixed(1).replace(/\.0$/, '')}%`;
};
